import { AuthType, init } from "@thoughtspot/visual-embed-sdk"
import { useEffect } from "react"
import { useMutation } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import { generateThoughtSpotToken } from "src/api/Analytics"

import { notifyBugsnag } from "src/utils/bugsnag"

// The Thoughtspot SDK's init() captures getAuthToken at init time, so a
// module-level ref lets the latest page's fetcher answer SDK callbacks
// across SPA navigations between Analytics pages (otherwise the SDK keeps
// calling the first page's fetcher and re-mints stale-scoped tokens).
let sdkInitialized = false
const tokenFetcherRef = {
  current: () =>
    Promise.reject(new Error("Thoughtspot SDK not yet initialized")),
}

export const useThoughtSpotInit = (thoughtspotHost, { scope } = {}) => {
  const { marinaSlug } = useMarina()

  const { mutateAsync: fetchToken } = useMutation({
    mutationFn: () => generateThoughtSpotToken({ marinaSlug, scope }),
  })

  tokenFetcherRef.current = fetchToken

  useEffect(() => {
    if (!sdkInitialized) {
      init({
        thoughtSpotHost: thoughtspotHost,
        authType: AuthType.TrustedAuthTokenCookieless,
        autoLogin: true,
        disableLoginRedirect: true,
        getAuthToken: async () => {
          try {
            const data = await tokenFetcherRef.current()
            return data.token
          } catch (error) {
            notifyBugsnag(error, { thoughtspot: { stage: "getAuthToken" } })
            throw error
          }
        },
      })
      sdkInitialized = true
    }
  }, [thoughtspotHost])
}
